import React, { useEffect, useState } from 'react';
import Button from '../../common/Button.js';
import Alert from '../../common/Alert.js';
import {
  emptyParcel,
  recomputeParcel,
  validateCargoParcels,
} from '../../../utils/cargoParcelUtils.js';
import PackageDimensionForm from './PackageDimensionForm.js';
import PackageDimensionModalShell from './PackageDimensionModalShell.js';

/**
 * Add packages modal.
 * - Default: blank form for first-time add (replaces parcels on save)
 * - appendMode: blank form only; on save appends to existingParcels
 */
const AddPackageDimensionModal = ({
  isOpen,
  onClose,
  onSave,
  existingParcels = [],
  appendMode = false,
  ratePerKg = 0,
}) => {
  const existingCount = Array.isArray(existingParcels) ? existingParcels.length : 0;
  const startSrNo = appendMode ? existingCount + 1 : 1;
  const [draft, setDraft] = useState([emptyParcel(startSrNo)]);

  useEffect(() => {
    if (!isOpen) return;
    setDraft([emptyParcel(appendMode ? existingCount + 1 : 1)]);
  }, [isOpen, appendMode, existingCount]);

  if (!isOpen) return null;

  const handleSave = () => {
    const error = validateCargoParcels(draft, startSrNo);
    if (error) {
      Alert.error(error);
      return;
    }

    const newRows = draft.map((row, i) => {
      const computed = recomputeParcel(row);
      const sr = appendMode ? existingCount + i + 1 : i + 1;
      return {
        ...computed,
        sr_no: sr,
        package_name: computed.package_name || 'PACKAGE',
      };
    });

    if (appendMode) {
      const base = (existingParcels || []).map(recomputeParcel);
      onSave([...base, ...newRows]);
    } else {
      onSave(newRows);
    }
    onClose();
  };

  return (
    <PackageDimensionModalShell
      title="Add Packages"
      onClose={onClose}
      footer={
        <div className="flex flex-row justify-end gap-2 sm:gap-3">
          <Button
            type="button"
            variant="secondary"
            onClick={onClose}
            className="flex-1 sm:flex-none sm:w-auto"
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="primary"
            onClick={handleSave}
            className="flex-1 sm:flex-none sm:w-auto"
          >
            Save
          </Button>
        </div>
      }
    >
      <PackageDimensionForm
        parcels={draft}
        onChange={setDraft}
        startSrNo={startSrNo}
        ratePerKg={ratePerKg}
        headerHint={
          appendMode
            ? 'Fill in the new package details below. Existing packages stay as they are.'
            : 'Fill in package details below. You can add more packages from here if needed.'
        }
      />
    </PackageDimensionModalShell>
  );
};

export default AddPackageDimensionModal;
